import styled from 'styled-components';
import moment from 'moment';
import { translate } from 'react-i18next';

// Services
import { dateWithTimezone } from 'src/services/date';
import { getPractitionerName, getTranslateDocSpecialties } from '../../../services/appointments';

const CardWrapper = styled.div`
  padding: 0.8em;
  box-sizing: border-box;
`;

const Card = styled.div`
  box-sizing: border-box;
  border: 1px solid ${p => p.theme.color.border};
  border-radius: 5px;
  background: white;
  .button-section {
    button {
      text-transform: capitalize;
      font-size: 1em;
      color: ${p => p.theme.color.primary};
      width: 50%;
      padding: 0.65em;
      box-sizing: border-box;
      transition: opacity 0.25s ease-in-out;
      &:hover {
        opacity: 0.7;
        cursor: pointer;
      }
      &.reject {
        color: ${p => p.theme.color.error};
        border-right: 1px solid ${p => p.theme.color.border};
      }
    }
  }
`;

const InfoBlock = styled.div`
  padding: 0.5em;
  border-bottom: 1px solid ${p => p.theme.color.border};
  font-size: 0.95em;
  .name {
    span:first-of-type {
      font-weight: bold;
      padding-right: 0.5em;
      text-transform: uppercase;
    }
  }
  .options {
    margin-top: 0.1em;
    font-size: 0.9em;
    color: ${p => p.theme.color.label};
  }
  .new {
    color: ${p => p.theme.color.successGreen};
  }
`;

const Caption = styled.p`
  margin: 0 0 0.8em;
  font-size: 0.9em;
  display: flex;
  justify-content: space-between;
  .bold {
    font-weight: bold;
  }
`;

export default translate()(props => {
  const { data, practitionersList, i18n, onChoose } = props;
  const personalData = data.patient;
  const practitionerData =
    data.practitionerId &&
    Array.isArray(practitionersList) &&
    practitionersList.find(pr => pr.id === data.practitionerId);

  return (
    <CardWrapper>
      <Caption>
        <span>{i18n.t('unplanned_arrival')}</span>
        <span className="bold">{dateWithTimezone(data.arrivedDateTime)}</span>
      </Caption>

      {personalData ? (
        <Card>
          {/* ──── Patient info ──────────────────────────────────────────────────────────────── */}
          <InfoBlock>
            <div className="name">
              <span>{personalData.lastName}</span>
              <span>{personalData.firstName}</span>
            </div>
            <div className="options">
              {`${moment(personalData.birthDate).format('DD.MM.YYYY')} | ${i18n.t(
                personalData.gender ? `gender_${personalData.gender.toLowerCase()}` : 'no_data'
              )}`}
              {personalData.isNew && (
                <span>
                  {' '}
                  | <span className="new">{i18n.t('new')}</span>
                </span>
              )}
            </div>
          </InfoBlock>

          {/* ──── Practitioner info ─────────────────────────────────────────────────────────── */}
          {practitionerData ? (
            <InfoBlock>
              <div>
                <span>{getPractitionerName(practitionerData)}</span>
              </div>
              <div className="options"> {getTranslateDocSpecialties(practitionerData)}</div>
            </InfoBlock>
          ) : null}

          {/* ──── Buttons section ───────────────────────────────────────────────────────────── */}
          <div className="button-section">
            <button className="reject" onClick={() => onChoose && onChoose('reject', data)}>
              {i18n.t('reject')}
            </button>
            <button onClick={() => onChoose && onChoose('add', data)}>{i18n.t('add')}</button>
          </div>
        </Card>
      ) : null}
    </CardWrapper>
  );
});
